import { combineReducers } from 'redux';
import {
  createSimpleKeyValueReducer,
  createToggleAndSetReducer,
} from '../../../redux-util/general-helpers';
import * as act from './actions';
import { withDestroyViewerReset } from '../../../reset-reducer-helpers';

export default withDestroyViewerReset(
  combineReducers({
    isFullScreen: createToggleAndSetReducer(
      act.toggleFullScreen().type,
      act.setFullScreen().type,
      false
    ),
    zoomScalingFactor: createSimpleKeyValueReducer(
      act.setZoomScalingFactor().type,
      1
    ),
  })
);
